import Grid from '@material-ui/core/Grid';
import Deck from '@material-ui/icons/Deck';
import Room from '@material-ui/icons/Room';
import classNames from 'classnames';
import _ from 'lodash';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import * as TELEMETRY from '../App/Constants/Telemetry';
import { TileStatus } from '../App/Constants/TileStatus';
import DashboardStore from '../App/Stores/DashboardStore';
import AuthorizationStore from '../App/Stores/AuthorizationStore';
import Tile from './Tile';
import StreamArticle from '../App/Models/StreamArticle';

interface Props {
  authorizationStore: AuthorizationStore;
  dashboardStore: DashboardStore;
  title: string;
  loadData: Function;
  initialStatus?: TileStatus;
}

@observer
class EventsStream extends Tile<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleEventsClick = (article: StreamArticle) => {
    window.telemetry.logEvent(TELEMETRY.EVENTS.DASHBOARD_EVENTS_STREAM);
    this.props.dashboardStore.updateSelectedArticle(article)
  }

  getThumb(article: StreamArticle){
    let url;
    if(article.ThumbnailMedia ){
      url = window.appSettings.aemStreamContentUrl + article.ThumbnailMedia._path; 
    } else if(article.ExternalThumbnailMedia){
      url = article.ExternalThumbnailMedia._path;
    } else {
      url = '';
    }
    return url;
  }

  render() {

    const { dashboardStore } = this.props;
    const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

    if (dashboardStore!.eventsArticlesStatus === TileStatus.LOADED || dashboardStore!.eventsArticlesCurrentPage > 1) {
      return (
        <>
          {dashboardStore!.eventsArticles.map(article => {
            const thumb = this.getThumb(article);                   
            const hero = article.heroMedia != null ? article.heroMedia : article.externalHeroMedia;
            const first = article.firstMedia != null ? article.firstMedia : article.externalFirstMedia;
            const second = article.secondMedia != null ? article.secondMedia : article.externalSecondMedia;
            const third = article.thirdMedia != null ? article.thirdMedia : article.externalThirdMedia;
            const fourth = article.fourthMedia != null ? article.fourthMedia : article.externalFourthMedia;
            return (
            <div className="c-dashboard__tile-stream-events-card" key={article.id}>
              <div className={classNames('c-dashboard__tile-stream-events-image', _.isEmpty(thumb) ? 'no-thumbnail' : '')}>
                <a target="_blank" onClick={() => this.handleEventsClick(article)}>
                  <img src={thumb} />
                </a>
              </div>
              <div className="c-dashboard__tile-stream-events-info">
                <div className={classNames('c-dashboard__tile-stream-events-info-title-content', _.isEmpty(article.Title) ? 'no-summary' : '')}>
                  <span className="c-dashboard__tile-stream-events-info-header-title">
                    <a target="_blank" onClick={() => this.handleEventsClick(article)}>
                      {article.Title}
                    </a>
                  </span>
                </div>
                <div className={classNames('c-dashboard__tile-stream-events-info-content', _.isEmpty(article.Summary.plaintext) ? 'no-summary' : '')}>
                  <ResponsiveEllipsis
                    className="c-dashboard__tile-stream-events-info-content-text"
                    text={article.Summary.plaintext ? article.Summary.plaintext : ''}
                    maxLine="4"
                    ellipsis="..."
                  />
                </div>
                <Grid item={true} xs={12}>
                  <div className="c-dashboard__tile-stream-events-info-footer">
                    <div className="c-dashboard__tile-stream-events-info-date">
                      <div>Event Date: {moment(article.EventDate).format('D MMM YYYY')}</div>
                    </div>
                    <div className="c-dashboard__tile-stream-events-info-location">
                        Location: {article.Location}
                    </div>
                  </div>
                </Grid>
              </div>
            </div>
          );
          })}
        </>
      );
    } else {
      return super.render();
    }

  }
}

export default EventsStream;